import React from "react"
import axios from "axios"
import { notify } from "react-notify-toast"
import "./model_style.css"
import Avatar from "react-avatar-edit"
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import CancelButton from "../../Components/Buttons/CancelButton"
import Modal from "../../Components/Modal/Modal"
import moment from 'moment'
import { connect } from "react-redux"
import { updateUserDetails } from "../../redux/college/college.actions"
import { API } from "../../API"
import { handleLogErrorToSlack } from "../../Helper"

class UploadAvatarCollege extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      preview: null,
      file: null,
      Name: null,
      newFileName: "",
      oldFileName: null,
      email_notified: false,
      rotate:0
    }

    this.onCrop = this.onCrop.bind(this)
    this.onClose = this.onClose.bind(this)
    this.UploadAvatarsNow = this.UploadAvatarsNow.bind(this)
    this.onCropDefault = this.onCropDefault.bind(this)
    this.urltoFile = this.urltoFile.bind(this)
    this.onBeforeFileLoad = this.onBeforeFileLoad.bind(this)
  }

  urltoFile = (url, filename, mimeType) => {
    mimeType = mimeType || (url.match(/^data:([^;]+);/) || "")[1]
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer()
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType })
      })
  }

  onClose = () => {
    this.setState({ preview: null })
  }

  onCrop = (preview) => {
    this.setState({ preview })
    // this.setState({src:})

    this.urltoFile(preview, this.state.Name).then((file) => {
      this.setState({ file: file })
    })
  }

  onBeforeFileLoad = (elem) => {
    if (elem.target.files[0].type === "application/pdf") {
      elem.target.value = ""
      notify.show("Invalid file format, please select file type other than pdf")
    }
  }

  UploadAvatarsNow = () => {
    const file = this.state.file
    const today = moment()
    const time = today.format('HH:mm:ss')
    const day = today.format('_yy_MM_DD_')

    if (file) {
      const [fileName, fileType] = file.name.split(".")
      this.setState({ oldFileName: fileName })
      // const updateUser = this.props.updateUser;
      //_id: this.props.user._id is undefined. Changed to customer_id
      API.uploadFileToS3({
        fileName: `profilePic${day}${time}`,
        fileType: fileType,
        _id: this.props.user.customer_id,
      })
        .then((response) => {
          const returnData = response.data.data.returnData
          const signedRequest = returnData.signedRequest
          const url = returnData.url
          const options = {
            headers: {
              "Content-Type": fileType,
            },
          }
          axios
            .put(signedRequest, file, options)
            .then((response2) => {
              const newUser = Object.assign({}, this.props.user)
              newUser.photo = url
              newUser.profile_photo_name = this.state.oldFileName
              this.props.updateUserDetails(newUser)
              this.forceUpdate()
              this.props.showPopup(false)
            })
            .catch((error) => {
              handleLogErrorToSlack(error, true)
              console.log(error, "a")

              alert("ERROR " + JSON.stringify(error))
            })
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      // show uploading error
      console.log("upload error")
    }
  }

  onCropDefault = (preview) => {
    this.setState({ defaultPreview: preview })
  }

  onFileLoad = (e) => {
    this.setState({ file: e })
    this.setState({ Name: e.name })
  }

  onhide = () => {
    this.props.showPopup(false)
  }

  render() {
    return (
      <Modal
        show={true}
        className="avatar-upload-modal"
        header="Upload a Professional Photo"
        onClose={this.onhide}
      >
        <div className="">
          <div className="row upload-avatar-form-box">
            <div className="upload-avatar-form">
              <Avatar
                id="imgupload"
                width={290}
                height={290}
                rotate={0}
                onCrop={this.onCrop}
                onClose={this.onClose}
                src={this.state.preview}
                onFileLoad={this.onFileLoad}
                onBeforeFileLoad={this.onBeforeFileLoad}
                alt="Preview"
              />
            </div>
          </div>
          <div className="row upload-button-box">
            <div className="col-md-6 mb-2 mb-md-0">
              <CancelButton onClick={this.onhide}>Cancel</CancelButton>
              {/* <Button className="btn btn-block btn-c secondary-button-no-margin-hover" onClick={handleClose}>Cancel</Button> */}
            </div>
            <div className="col-md-6">
              <ConfirmButton onClick={this.UploadAvatarsNow}>
                Submit
              </ConfirmButton>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.college.user
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateUserDetails: (details) => dispatch(updateUserDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadAvatarCollege);
